import React, { FC } from "react";
import { Author } from "./Author.interface";
import { Image } from "../../Utility/MediaBuilder/Image";
import { Typography } from "../../Fundamentals/Typography";

export interface IAuthorInfoProps {
  classes?: {
    root?: string;
  };
  author: Author;
  customMedia?: JSX.Element;
}

const AuthorInfo: FC<IAuthorInfoProps> = ({ classes, author, customMedia }) => {
  return (
    <div className={`${classes?.root} ?? d-flex flex-row align-items-center`}>
      <div className="me-6 ratio ratio-1x1 ratio-img w-40px h-40px">
        {customMedia ?? (
          <Image
            content="person"
            classes={{ root: "rounded-circle" }}
            {...author.avatar}
          />
        )}
      </div>
      <div className="overflow-hidden">
        <Typography
          variant="text-nav"
          as="h3"
          classes={{ root: "max-lines max-lines--2 mb-3" }}
        >
          {author.fullName}
        </Typography>
        {author.description && (
          <Typography
            variant="text-desc"
            as="div"
            classes={{ root: "max-lines max-lines--1 max-lines--single-line" }}
          >
            {author.description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default AuthorInfo;
